export const REQUEST_ACCESS_URL = '/rest/internal/latest/project-access/access-requested';

export type AccessRequestPayload = {
	accountId: string | null;
	boardId?: number | null;
	projectKey?: string | null;
	issueKey?: string | null;
	message?: string | null;
};

export const requestAccess = async (
	payload: AccessRequestPayload,
	requestUrl?: string,
): Promise<Response> => {
	const endpoint = requestUrl || REQUEST_ACCESS_URL;
	// we return nothing on purpose to be vague, not disclose if the project exists or not,
	// so we use fetch instead of performPutRequest as performPutRequest will return null for empty response
	return fetch(endpoint, {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(payload),
	});
};
